import React from 'react';
import type { CSSProperties, InputHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  focused?: boolean;
  css?: CSSProperties;
};

export const Input = styled(
  ({ focused, ...props }: InputProps) => <input {...props} type="text" />,
).attrs(({ css: style }: InputProps) => ({
  style,
}))<InputProps>`
  border: none;
  background: none;
  outline: none;
  position: absolute;
  height: 100%;
  width: 100%;
  display: block;
  text-align: center;
  padding: 5px;
  ${({ focused }: InputProps) =>
    focused &&
    css`
      box-shadow: inset 0 0 0 2px #2770ff;
    `}
`;
